var moduleMap = {
	"./MessageApp": () => {
		return Promise.all(/* __federation_expose_MessageApp */[__webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(878)]).then(() => (() => ((__webpack_require__(422)))));
	},
	"./EmployeeManagement": () => {
		return Promise.all(/* __federation_expose_EmployeeManagement */[__webpack_require__.e(107), __webpack_require__.e(989), __webpack_require__.e(156), __webpack_require__.e(752), __webpack_require__.e(939), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(161)]).then(() => (() => ((__webpack_require__(5197)))));
	},
	"./CustomerManagement": () => {
		return Promise.all(/* __federation_expose_CustomerManagement */[__webpack_require__.e(107), __webpack_require__.e(989), __webpack_require__.e(156), __webpack_require__.e(752), __webpack_require__.e(939), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(681)]).then(() => (() => ((__webpack_require__(6425)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};

__webpack_require__(3537)

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});